export default {
  http_errors: {
    400: 'Coś poszło nie tak... spróbuj ponownie za jakiś czas!',
    401: 'Brak uprawnień!',
    403: 'Coś poszło nie tak... spróbuj ponownie za jakiś czas!',
    404: 'Coś poszło nie tak... spróbuj ponownie za jakiś czas!',
    406: 'Nieprawidłowe dane do płatności lub ich ważność wygasła.',
    429: 'Za dużo prób. Prosimy spróbować ponownie za chwilę',
    500: 'Chwilowy problem z przekieowaniem do płatności. Wybierz inny sposób płatności lub spróbuj za chwilę jeszcze raz.',
    503: 'Błąd serwera. Prosimy spróbować ponownie',
    504: 'Przekroczono czas oczekiwania, proszę spróbować jeszcze raz',
  },
  header: {
    language: 'Język',
  },
  buttons: {
    cancel_payment: 'Anuluj płatność',
    continue_payments: 'Zapłać',
    back_to_store: 'Wróć na stronę sklepu',
    tooltip: 'Kliknij tutaj aby dokończyć płatność',
    select: 'Wybierz',
  },
  main_site_view: {
    sub_title: 'Agregator płatności On-line',
    main_description: 'Agregator pozwala skorzystać z jednego z wybranych sposobów płatności, płacąc za wybraną usługę, produkt. Klienci mogą wybrać najbardziej wygodna opcję płatności dla siebie, korzystając z jednego ze sprawdzonych i znanych rozwiązań. ',
    gateways_available: 'Obsługiwane sposoby płatności:',
    gateways: {
      payu: 'Operator płatności internetowych działający jako system, który daje możliwość dokonywania oraz otrzymywania wpłat przez Internet.',
      paypal: 'W PayPal klienci mogą płacić przy użyciu karty kredytowej bądź salda konta PayPal, które można zasilać przelewami z konta bankowego.',
      przelewy24: 'Serwis Przelewy24 udostępnia automatyczne płatności przelewami on-line z 286 banków w Polsce oraz kartami płatniczymi.',
      subscription: 'Płatności cykliczne za pośrednictwem PayU',
    },
    gateways_descriptions: '',
    more_info: 'Więcej informacji:',
    regulations: 'Regulamin Serwisu Telestrada Payments',
  },
  payment_actions_screen_schema: {
    gateways_list: {
      header_title: 'Wybierz sposób płatności',
      header_description: 'Wybierz dogodny dla Ciebie sposób płatności a następnie kliknij "Dokończ płatność"',
    },
    credit_card: {
      header_title: 'Płatność kartą',
      header_description: 'Uzupełnij dane dotyczące karty a następnie kliknij "Dokończ płatność"',
    },
    subscription: {
      header_title: 'Płatność cykliczna',
      header_description: 'Uzupełnij dane dotyczące karty a następnie kliknij "Dokończ płatność"',
    },
    gateways: {
      PayU: {
        description: `Operator płatności internetowych działający jako system, który daje możliwość dokonywania oraz otrzymywania wpłat przez Internet pomiędzy osobami posiadającymi konto e-mail. 
        PayU daje możliwość płacenia kartą kredytową lub przelewem bankowym.`,
        name: 'PayU',
      },
      PayPal: {
        description: `W systemie PayPal klienci mogą płacić przy użyciu karty kredytowej bądź salda konta PayPal, 
        które można zasilać przelewami z konta bankowego lub innego konta PayPal.`,
        name: 'PayPal',
      },
      Przelewy24: {
        description: `Serwis Przelewy24 udostępnia automatyczne płatności przelewami on-line z 286 banków w Polsce oraz kartami płatniczymi: Visa Classic, Visa Electron, EuroCard/MasterCard, 
        Diners Club, PBK, JCB.`,
        name: 'Przelewy24',
      },
      CardPayments: {
        description: 'Płatność w internecie odbywa się tą samą kartą, co w zwykłym sklepie. Obsługujemy karty debetowe i kredytowe, krajowe i zagraniczne. Płatności kartą obsługiwane jest przez serwis PayU',
        name: 'Płatność kartą',
      },
      Subscription: {
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse euismod gravida metus sit amet congue. Integer eu tortor mollis, vehicula neque laoreet, lacinia ex. Etiam eleifend nulla id dolor vestibulum dictum. Morbi sit amet ex varius, ultrices risus eu, tincidunt dui. Maecenas pharetra orci quis lorem tincidunt, vel pel',
        name: 'Subskrypcja',
      },
    },
    credit_card_form: {
      back: 'Wróć',
      form: {
        card_number: 'Numer karty',
        cvv: 'CVV2/CVC',
        exp_year: 'Rok',
        exp_month: 'Miesiąc',
        first_name: 'Imię',
        last_name: 'Nazwisko',
        email: 'Adres email',
      },
      placeholders: {
        card_number: 'Wpisz numer karty',
        cvv: 'Wpisz numer CVV2/CVC2',
        first_name: 'Wpisz imię',
        last_name: 'Wpisz nazwisko',
        email: 'Wpisz adres email',
      },
      errors: {
        required: 'Pole jest wymagane',
        card_number: 'Nieprawidłowy numer karty',
        cvv: 'Nieprawidłowa wartość CVV/CVC2',
        exp_year: 'Nieprawidłowa wartość',
        exp_month: 'Nieprawidłowa wartość',
        name: 'Nieprawidłowa wartość',
        email: 'Nieprawidłowy adres email',
      },
      extra: {
        credit_card: 'Typ karty: ',
      },
    },
    secure_form: {
      back: 'Wróć',
    },
    no_gateways: 'Brak możliwych sposobów płatności',
  },
  payment_summary: {
    header_title: 'Podsumowanie płatności',
    header_description: 'Poniżej znajduje się lista produktów oraz podsumowanie płatności',
    payment: {
      title: 'Tytuł płatności',
      product_name: 'Nazwa produktu',
      quantity: 'Ilość',
      price: 'Cena',
      selected_payment_method: 'Wybrana metoda płatności',
      no_selected_payment_method: 'Nie wybrano metody płatności!',
      summary_quantitiy: 'Ilość produktów',
      summary_amount: 'Suma',
    },
  },
  after_payment: {
    success: {
      code: 'OK',
      title: 'Płatność została przekazana do realizacji',
      description: 'Dziękujemy. Twoja płatność właśnie została przekazana do realizacji. Za chwilę zostaniesz przekierowany na stronę sklepu.',
    },
    error: {
      code: 'BŁĄD',
      title: 'Ups... coś poszło nie tak',
      description: 'Twoja płatność została anulowana. Za chwilę zostaniesz przekierowany na stronę sklepu.',
    },
  },
  wrong_or_expired_token_page: {
    code: 'BŁĄD',
    title: 'Brak lub nieprawidłowy Numer Zlecenia',
    description: `Przekazano nieprawidłowy Numer Zlecenia lub jego ważność wygasła
      <div class="error-page">
        <small class="error-page__more-info">Więcej informacji: </small>
        <a href="https://www.telestrada.pl/wp-content/uploads/2022/12/regulamin-telestrada-payments.pdf" class="error-page__regulations">
          <i class="fa fa-file-pdf-o" aria-hidden="true"></i> Regulamin Serwisu Telestrada Payments
        </a>
      </div>
    `,
  },
};



// WEBPACK FOOTER //
// ./src/lang/PL.js